








































import { Component, Prop, Vue } from "vue-property-decorator";
import { Icon } from "vant";
import { IGetDetail } from "@/api/types";
@Component({
  components: { Icon }
})
export default class LiveHeader extends Vue {
  @Prop({ type: Object, default: () => {} })
  detail!: IGetDetail["data"];
  // 展示直播间详情
  showDetail = false;

  get hideDetailViewCount() {
    return this.$store.state.hideDetailViewCount;
  }

  get appIdFromUA() {
    return this.$store.state.appIdFromUA;
  }

  get viewCount() {
    const viewCount = Number(this.detail.viewCount);
    return viewCount < 10000
      ? viewCount
      : ((viewCount || 1) / 10000).toFixed(1) + "w";
  }

  get prefix() {
    const map = {
      0: "直播预告",
      1: "正在直播",
      2: "直播回顾"
    };

    return map[this.detail.status || 0];
  }
}
